export default "__VITE_ASSET__39ec9180__"